import { supabaseManager } from '@/services/supabase';
import { postResolveOrganizationFunction } from '@/services/supabase/registryFunctionClient';
import { PlatformMessage } from '@/types/platformMessages';

const mapRow = (row: Record<string, unknown>): PlatformMessage => ({
  id: row.id as string,
  organizationRegistryId: (row.organization_registry_id as string | null) ?? null,
  messageText: row.message_text as string,
  expiresAt: new Date(row.expires_at as string),
  isActive: row.is_active as boolean,
  isUrgent: row.is_urgent as boolean,
  isDismissible: row.is_dismissible as boolean,
  createdAt: new Date(row.created_at as string),
  updatedAt: new Date(row.updated_at as string),
});

export const platformMessagesService = {
  async getActiveForOrganization(organizationSlug: string): Promise<PlatformMessage[]> {
    const client = supabaseManager.getMainClient();
    const normalizedSlug = organizationSlug.trim();

    const orgRow = await postResolveOrganizationFunction<{ id: string }>({
      organizationSlug: normalizedSlug,
    });

    const orgRegistryId = orgRow?.id;
    const now = new Date().toISOString();

    let query = client
      .from('platform_messages')
      .select('*')
      .eq('is_active', true)
      .gt('expires_at', now);

    if (orgRegistryId) {
      query = query.or(`organization_registry_id.is.null,organization_registry_id.eq.${orgRegistryId}`);
    } else {
      query = query.is('organization_registry_id', null);
    }

    const { data, error } = await query.order('created_at', { ascending: false });
    if (error) throw error;

    return (data ?? []).map(mapRow);
  },
};
